import cn from 'classnames';
import React from 'react';

export interface Props {
  layout: 'gray' | 'danger' | 'success' | 'brand' | 'red-sale' | 'green';
  size?: 'sm' | 'base' | 'xs';
  className?: string;
}

const Badge: React.FC<React.PropsWithChildren<Props>> = ({ children, layout, className, size }) => {
  return (
    <div
      className={cn(
        {
          'inline-block rounded-full leading-none font-black tracking-wide uppercase': true,

          'bg-grey-200 text-text-secondary': layout === 'gray',
          'bg-primary-main text-text-dark-bg-contrast-white': layout === 'brand',
          'bg-brand-cta text-text-dark-bg-contrast-white': layout === 'danger',
          'bg-badge-discount text-text-dark-bg-contrast-white': layout === 'red-sale',
          'bg-brand-brilliant-green text-text-dark-bg-contrast-white': layout === 'green',

          'px-4 py-2 text-xs': size === 'base',
          'px-3 py-1 text-xs': size === 'sm',
          'px-2 py-1 text-xs': size === 'xs',
        },
        className
      )}
    >
      {children}
    </div>
  );
};

Badge.defaultProps = {
  size: 'base',
  className: '',
};

export default Badge;
